import { DepartmentItemProps } from "apis";
import { lazy } from "react";

export const PageAdminDepartment = lazy(() => import("./List"));
export const PageAdminDepartmentCreate = lazy(() => import("./Add"));
export const PageAdminDepartmentUpdate = lazy(() => import("./Edit"));

export interface FormDepartmentValuesProps extends DepartmentItemProps { }